import { useEffect } from 'react';
import { useAuth } from '@/stores/use-auth';
import { startSessionKeepalive } from '@/lib/session-keepalive';

/**
 * Keeps the browser session warm while the user is signed in (proactive refresh + tab focus).
 */
export function SessionKeepalive(): null {
  const isAuthenticated = useAuth((state) => state.isAuthenticated);

  useEffect(() => {
    return startSessionKeepalive(isAuthenticated);
  }, [isAuthenticated]);

  return null;
}
